export enum EUserType {
    Customer = "CUSTOMER",
    Operator = "OPERATOR"
}